export interface Base {
  created_on: string; // Creation date in Claire
  updated_on: string; // Last update date in Claire
}

export interface BaseImmutable {
  created_on: string; // Creation date in Claire
}
